import { usePaginatedRequest } from '~/ui/hooks/utils/service/use-paginated-request'

import { infiniteListContextFactory } from './infinite-list-context-factory'

/**
 * @deprecated The InfiniteListProvider method should not be used, you should use the new InfiniteScroll provider.
 */
export const { useInfiniteList, InfiniteListProvider } = infiniteListContextFactory<any, any>(usePaginatedRequest)
